import { C as Cookies } from './index2.js';

const CookieService = {
    getConsent() {
        const defaultConsent = {
            necessary: true,
            performance: false,
            functional: false,
            targeting: false,
            social: false,
        };
        if (!window.OptanonActiveGroups || !window.Optanon) {
            return defaultConsent;
        }
        return {
            necessary: window.OptanonActiveGroups.includes('C0001'),
            performance: window.OptanonActiveGroups.includes('C0002'),
            functional: window.OptanonActiveGroups.includes('C0003'),
            targeting: window.OptanonActiveGroups.includes('C0004'),
            social: window.OptanonActiveGroups.includes('C0005'),
        };
    },
    setCookie(name, value, expires) {
        Cookies.set(name, value, expires);
    },
    getCookie(name) {
        let cookie;
        if (name) {
            // returns a string with the value
            cookie = Cookies.get(name);
        }
        else {
            // returns a object with name and value of the cookie
            cookie = Cookies.get();
        }
        return cookie;
    },
    removeCookie(name) {
        Cookies.remove(name);
    },
};

export { CookieService as C };

//# sourceMappingURL=index11.js.map